import { styled } from "@linaria/react"

import { Vertical } from "@/components/Flex.ts"

import type { Property } from "csstype"


export const Centered = styled(Vertical)<{
  vertical?: boolean
  horizontal?: boolean
  maxWidth?: Property.MaxWidth
  minHeight?: Property.MinHeight
  padding?: Property.Padding
  gap?: Property.Gap
}>`
  flex-grow: 1;

  justify-content: ${props => props.vertical === undefined || props.vertical ? "center" : "normal"};
  align-items: ${props => props.horizontal === undefined || props.horizontal ? "center" : "normal"};
  gap: ${props => props.gap || "normal"};

  max-width: ${props => props.maxWidth || "100%"};
  min-height: ${props => props.minHeight || "100%"};

  padding: ${props => props.padding || "0"};
`
